import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  TextField,
  IconButton,
  Box,
  Select,Link,
  Button,
  Checkbox,FormHelperText,
  MenuItem,
  Chip,
   CircularProgress,
  Autocomplete,
  ListItemText,
  InputLabel,
  FormControl,
} from "@mui/material";
import { useAuth } from "../../../../AuthProvider";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DeleteIcon from "@mui/icons-material/Delete";
import { GlobalStyles, margin } from "@mui/system";
import Swal from "sweetalert2";
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

function DigitalClasses() {

  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const { userId, oId ,pId, board,role} = useAuth();
  
  const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState('');
  const isPrincipal = role?.startsWith("PRINCIPAL") || false;
  const UserId = userId || selectedUsers;

  const [teacherrecipients, setTeacherRecipients] = useState([]);
  const [teacherLoading, setTeacherLoading] = useState(false);

  const [loadingData, setLoadingData] = useState(true);
  const [loading, setLoading] = useState(false);
  const [teachers, setTeachers] = useState([]);
  const [meetings, setMeetings] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [errors, setErrors] = useState({});
  const [recipientsRoleUserIds, setRecipients] = useState([]);
 

  const [filteredData, setFilteredData] = useState([]);
    const [originalData, setOriginalData] = useState([]); 


  const [sscClassSectionData, setSscClassSectionData] = useState([]);
  const [sscClassOptions, setSscClassOptions] = useState([]);
  const [sscSectionOptions, setSscSectionOptions] = useState([]);
  const [sscSelectedClass, setSscSelectedClass] = useState("");
  const [sscSelectedSection, setSscSelectedSection] = useState("");

  
  // INTERMEDIATE states
  const [interSectionOptions, setInterSectionOptions] = useState([]);
  const [interSelectedClass, setInterSelectedClass] = useState("");
  const [interSelectedSection, setInterSelectedSection] = useState("");
  const [courseOptions, setCourseOptions] = useState([]);
  const [selectedCourseType, setSelectedCourseType] = useState("");

  const [sscClassSectionMap, setSscClassSectionMap] = useState({});


  const classOptions = ["Class 1", "Class 2", "Class 3"];
  const sectionOptions = ["Section-A", "Section-B", "Section-C"];



 const [formData, setFormData] = useState({
  title:"",
  meetingDate: "",
  time:'',
 romanNumberClass:"",
 sections:"",
  meetingLink: "",
  description:'',

  postedDate: "",
  teacherrecipients: null, // ← CLEAR SELECTED TEACHER
  
});

// const handleTimeChange = (value) => {
//   if (value) {
//     const formattedTime = dayjs(value).format("hh:mm A"); // Format to "06:30 PM"
//     setFormData((prev) => ({
//       ...prev,
//       time: formattedTime,
//     }));
//   }
// };
const handleTimeChange = (value) => {
  if (value) {
    const formattedTime = dayjs(value).format("hh:mm A");
    setFormData((prev) => ({
      ...prev,
      time: formattedTime,
    }));

    // Clear time error when time is selected
    setErrors((prev) => ({
      ...prev,
      time: "", // remove the error
    }));
  }
};




  // Fetch Teachers
    const fetchTeachers = async () => {
  setTeacherLoading(true);
  try {
    const response = await fetch(
      `${baseUrl}/api/scheduleMeetings/getAllTeachers/${oId}/TEACHER/${pId}`
    );

    const data = await response.json();
    setTeacherRecipients(
      data.map((teacher) => ({
        teacherId: teacher.teacherId,
        teacherFirstName: teacher.teacherFirstName,
        teacherLastName: teacher.teacherLastName,
      }))
    );
  } catch (error) {
    // toast.error(error.message);
  } finally {
    setTeacherLoading(false);
  }
};

useEffect(() => {
  fetchTeachers();
}, [baseUrl, oId]);




    // -------------------------------------------
//           For SSC functions
// -------------------------------------------

// ---- Fetch Class + Sections for SSC (School) ----
const fetchClassRegistrationData = async () => {
  try {
    const response = await fetch(`${baseUrl}/api/dynamic-classReg/class-registrations/${oId}/${pId}`);
    const data = await response.json();

    if (response.ok && Array.isArray(data)) {
      // Group by class and merge section strings into unique values
      const classSectionMap = {};

      data.forEach(item => {
        const className = item.classRegistration;
        const sectionList = item.sections.split(",").map(s => s.trim());

        if (!classSectionMap[className]) {
          classSectionMap[className] = new Set();
        }

        sectionList.forEach(section => classSectionMap[className].add(section));
      });

      const classes = Object.keys(classSectionMap);
      setSscClassOptions(classes); // Class dropdown options
      setSscClassSectionMap(classSectionMap); // Save for section filtering later

      // No default selection
      setSscSelectedClass("");
      setSscSelectedSection("");
      setSscSectionOptions([]);
    }
  } catch (error) {
    console.error("Error fetching SSC data:", error);
  }
};





// -------------------------------------------
//           For Intermediate functions
// -------------------------------------------

// ---- Fetch Courses for INTERMEDIATE ----
const fetchCourseData = async () => {
  if(!interSelectedClass) return;
  try {
    const response = await fetch(`${baseUrl}/api/dynamic-classReg/getAllcoursesAccordingClasses/${pId}?romanNumberClass=${interSelectedClass}`);
    const data = await response.json();
    if (response.ok && Array.isArray(data)) {
      setCourseOptions(data);
      if (!selectedCourseType) {
        setSelectedCourseType(data[0] || "");
      }
    } else {
      setCourseOptions([]);
    }
  } catch (error) {
    console.error("Error fetching course data:", error);
    setCourseOptions([]);
  }
};


// Fetch course options if board is INTERMEDIATE
useEffect(() => {
  if (board === "INTERMEDIATE") {
    fetchCourseData();
  }
}, [interSelectedClass,board, oId]);

// ---- Fetch Sections for INTERMEDIATE ----
const fetchSectionsData = async () => {
  if (!selectedCourseType) {
    setInterSectionOptions([]);
    return;
  }
  try {
    const response = await fetch(
      `${baseUrl}/api/dynamic-classReg/getAllClass-registrations/${interSelectedClass}/${selectedCourseType}/${pId}`
    );
    const data = await response.json();
    if (response.ok && Array.isArray(data) && data.length > 0) {
      const sectionsString = data[0].sections;  // because your data is like [{ sections: "Section-A,Section-B" }]
      const sections = sectionsString.split(",").map(section => section.trim());
      
      setInterSectionOptions(sections);

      if (sections.length > 0) {
        setInterSelectedSection(sections[0]);
      } else {
        setInterSelectedSection("");
      }
    } else {
      setInterSectionOptions([]);
      setInterSelectedSection("");
    }
  } catch (error) {
    console.error("Error fetching INTERMEDIATE data:", error);
  }
};




useEffect(() => {
  const loadClassData = async () => {
    if (board === "INTERMEDIATE") {
      await fetchSectionsData();
    } else if (board === "SSC") {
      await fetchClassRegistrationData();
    }
  };
  loadClassData();
}, [board, selectedCourseType, oId]); 

   




  // for getAll api
    const fetchMeetings = async () => {
      
      setLoadingData(true); // Start loading
      try {
        const response = await fetch(
          //api/digitalClassRoom/getAllUpcoming/principal/{orgId}/{prId}
          `${baseUrl}/api/digitalClassRoom/getAllUpcoming/principal/${oId}/${pId}`
        );
        const data = await response.json();
  
         // ✅ Sort notices by purposeDate (future dates first)
         data.sort((a, b) => new Date(b.purposeDate) - new Date(a.purposeDate));
  
        if (Array.isArray(data)) {
          setMeetings(data); // Assuming `setMeetings` is your state setter
        } else {
          console.error("API response is not an array:", data);
          setMeetings([]); // Set to an empty array if response is invalid
        }
      } catch (error) {
        setMeetings([]);
        console.error(error);
        // toast.error(error.message);
      } finally {
        setLoadingData(false); // Stop loading
      }
    };
    useEffect(() => {
      fetchMeetings();
    }, [pId]);

 const validateField = (field, value) => {
  switch (field) {
    case "recipientsRoleUserIds":
      return !value || !value.teacherId ? "Please select a teacher" : "";
    // other cases...
    default:
      return "";
  }
};


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: validateField(name, value),
    }));
  };




const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);

  if (!validateForm()) {
    console.log("Validation failed", errors);
    setLoading(false);
    return;
  }

  try {
    const teacherId = formData.teacherrecipients?.teacherId;

    if (!teacherId) {
      toast.error("Please select a recipient.");
      setLoading(false);
      return;
    }

    const formDataToSend = new FormData();

  formDataToSend.append("title", formData.title);
    formDataToSend.append("meetingDate", formData.meetingDate);
    formDataToSend.append("time", formData.time);
     formDataToSend.append("meetingLink", formData.meetingLink);
    formDataToSend.append("description", formData.description);

    // Send class/section info based on board
    if (board === "SSC") {
      formDataToSend.append("romanNumberClass", sscSelectedClass || "");
      formDataToSend.append("sections", sscSelectedSection || "");
    }

    if (board === "INTERMEDIATE") {
      formDataToSend.append("course", selectedCourseType || "");
      formDataToSend.append("romanNumberClass", interSelectedClass || "");
      formDataToSend.append("sections", interSelectedSection || "");
    }

    const url = `${baseUrl}/api/digitalClassRoom/save/${oId}/${pId}/${teacherId}`;
    console.log("Submitting to URL:", url);
    console.log("FormData:", Object.fromEntries(formDataToSend.entries()));

    const response = await fetch(url, {
      method: "POST",
      body: formDataToSend,
    });

    if (!response.ok) throw new Error("Failed to save meeting");

    toast.success("Meeting Scheduled Successfully", { autoClose: 1000 });
    fetchMeetings();

    // Reset form
    setFormData({
       meetingLink: "",
       romanNumberClass:"",
        sections:"",
        course:'',
       meetingDate: "",
        postedDate: "",
        title:"",
        time:'',
        description:'',
        teacherrecipients: null, // ← CLEAR SELECTED TEACHER
    });
    setSscSelectedClass("");
    setSscSelectedSection("");
    setInterSelectedClass("");
    setInterSelectedSection("");
    setSelectedCourseType("");

  } catch (error) {
    toast.error(error.message);
    console.error("Error:", error);
  } finally {
    setLoading(false);
  }
};





   const validateForm = () => {
  const newErrors = {};

  if (!formData.teacherrecipients)
    newErrors.recipients = "Select a Teacher";

 if (!formData.title.trim()) {
  newErrors.title = "Meeting title is required";
} else if (!/^[A-Za-z0-9\s-]+$/.test(formData.title)) {
  newErrors.title = "Only letters, numbers, spaces, and hyphens are allowed";
}

    // if (formData.recipients.trim())
    //   newErrors.recipients = "Select At least one Recipient";
    // if (!formData.time) newErrors.time = "Meeting time is required";
    

     if (!formData.meetingLink) newErrors.meetingLink = "Meeting Link is required";



 

  if (!formData.meetingDate) {
    newErrors.meetingDate = "Meeting date is required";
  } else {
    const today = new Date().toISOString().split("T")[0];
    if (formData.meetingDate < today)
      newErrors.meetingDate = "Meeting date cannot be in the past";
  }

  if (!formData.time) {
    newErrors.time = "Please select a Time";
  }


   if (!formData.romanNumberClass) {
    newErrors.romanNumberClass = "Please select a class";
  }

  setErrors(newErrors);
  return Object.keys(newErrors).length === 0;
};


   const handleDeleteMeeting = (data) => {
      Swal.fire({
        title: "Are you sure?",
  
        text: `You Want To Delete "${data.title}" From The Meeting List.`,
  
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, delete it!",
      }).then(async (result) => {
        // ✅ Using async here
        if (result.isConfirmed) {
          try {
            const response = await fetch(
              `${baseUrl}/api/digitalClassRoom/delete/${data.dcId}`,
           
              { method: "DELETE" }
            );
  
            if (!response.ok) throw new Error("Failed to delete the meeting");
            // fetchTeachers();
            fetchMeetings();
  
            // Swal.fire("Deleted!");
            toast.success("Your meeting has been deleted.", "success");
          } catch (error) {
            // Swal.fire("Error!", error.message, "error");
            toast.error(error.message);
          }
        }
      });
    };



  // const filteredMeetings = meetings.filter((meeting) => {
  //   const query = searchQuery.toLowerCase();
  //   return (
  //     meeting.title.toLowerCase().includes(query) ||
  //     meeting.meetingDate.includes(query)
  //   );
  // });

const filteredMeetings = meetings.filter((meeting) => {
  const query = searchQuery.trim().toLowerCase();

  const title = (meeting.title || "").toLowerCase();
  
  let formattedDate = "";
  if (Array.isArray(meeting.meetingDate)) {
    const [year, month, day] = meeting.meetingDate;
    formattedDate = `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
  } else {
    formattedDate = (meeting.meetingDate || "").toLowerCase();
  }

  return title.includes(query) || formattedDate.includes(query);
});



  return (
    <Card
      style={{
        margin: "60px 20px",
        padding: "10px",
        backgroundColor: "#fff",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        borderRadius: "8px",
      }}
    >
      <CardContent>
        <Typography
          variant="h4"
          style={{ fontWeight: "bold", color: "#333", textAlign: "center" }}
        >
          Digital Classes
        </Typography>

        <Grid container spacing={2} sx={{ marginTop: "10px", alignItems: "stretch" }}>
          {/* Left Side Form */}
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                padding: "15px",
                borderRadius: "8px",
                boxShadow: "0px 6px 20px rgba(0, 0, 0, 0.25)",
                backgroundColor: "#ffffff",
              }}
            >
              <Typography
                variant="h6"
                sx={{ fontWeight: "bold", color: "#333", marginBottom: "15px" }}
              >
                Schedule Online Class
              </Typography>

              <form onSubmit={handleSubmit}>

                 <TextField
                                  name="title"
                                  label="Meeting Title"
                                  value={formData.title}
                                  onChange={handleChange}
                                  fullWidth
                                  sx={{ mb: 1 }}
                                  error={!!errors.title}
                                  helperText={errors.title}
                                />


                <TextField
  name="meetingDate"
  label="Schedule Date"
  type="date"
  value={formData.meetingDate}
  onChange={handleChange}
  fullWidth
  sx={{ mb: 2 }}
  error={!!errors.meetingDate}
  helperText={errors.meetingDate}
  InputLabelProps={{ shrink: true }}
  inputProps={{
    min: new Date().toISOString().split("T")[0]  // disables past dates in calendar picker
  }}
/>


                            
                <LocalizationProvider dateAdapter={AdapterDayjs}>
  <TimePicker
    label="Time"
    value={formData.time ? dayjs(formData.time, "hh:mm A") : null}
    onChange={handleTimeChange}
    sx={{ width: "100%", marginBottom: "10px" }}
    ampm
    slotProps={{
      textField: {
        fullWidth: true,
        sx: { mb: 1 },
        error: !!errors.time,
        helperText: errors.time || " ",
      },
    }}
  />
</LocalizationProvider>




                
                  {board === "SSC" && (
                    <>
                      <Box sx={{ mb: 2 }}>
                      
                        <FormControl fullWidth error={!!errors.romanNumberClass}>
  <InputLabel id="class-select-label">Select Class</InputLabel>
  <Select
    labelId="class-select-label"
    value={sscSelectedClass}
    label="Select Class"
    onChange={(e) => {
  const selected = e.target.value;
  setSscSelectedClass(selected);

 setFormData((prev) => ({
    ...prev,
    romanNumberClass: selected,
  }));

  // ✅ Clear the error for romanNumberClass if valid
  setErrors((prevErrors) => ({
    ...prevErrors,
    romanNumberClass: selected ? "" : "Please select a class",
  }));

  const sections = sscClassSectionMap[selected]
    ? Array.from(sscClassSectionMap[selected])
    : [];

  setSscSectionOptions(sections);
  if (sections.includes("Section-A")) {
    setSscSelectedSection("Section-A");
  } else if (sections.length > 0) {
    setSscSelectedSection(sections[0]);
  } else {
    setSscSelectedSection("");
  }
}}

  >
    {sscClassOptions.map((cls) => (
      <MenuItem key={cls} value={cls}>
        {cls}
      </MenuItem>
    ))}
  </Select>

  {errors.romanNumberClass && (
    <FormHelperText>{errors.romanNumberClass}</FormHelperText>
  )}
</FormControl>

                      </Box>

                      <Box sx={{ mb: 2 }}>
                        <FormControl size="medium" fullWidth>
                          <InputLabel id="section-select-label">Select Section</InputLabel>
                          <Select
                            labelId="section-select-label"
                            value={sscSelectedSection}
                            onChange={(e) => setSscSelectedSection(e.target.value)}
                            label="Select Section"
                            // sx={{ height: 35 }}
                            disabled={sscSectionOptions.length === 0}
                          >
                            {sscSectionOptions.map((section) => (
                              <MenuItem key={section} value={section}>{section}</MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Box>
                    </>
                  )}

                          
                          
                          {board === "INTERMEDIATE" && (
                            <>
                              <FormControl size="medium" fullWidth sx={{ mb: 2 }} error={!!errors.romanNumberClass}>
                                <InputLabel id="intermediate-class-select-label">Select Year</InputLabel>
                                <Select
                                  labelId="intermediate-class-select-label"
                                  value={interSelectedClass}
                                  // onChange={(e) => setInterSelectedClass(e.target.value)}
                                   onChange={(e) => {
  const selected = e.target.value;
  setInterSelectedClass(selected);

 setFormData((prev) => ({
    ...prev,
    romanNumberClass: selected,
  }));

  // ✅ Clear the error for romanNumberClass if valid
  setErrors((prevErrors) => ({
    ...prevErrors,
    romanNumberClass: selected ? "" : "Please select a class",
  }));

  const sections = sscClassSectionMap[selected]
    ? Array.from(sscClassSectionMap[selected])
    : [];

  setSscSectionOptions(sections);
  if (sections.includes("Section-A")) {
    setSscSelectedSection("Section-A");
  } else if (sections.length > 0) {
    setSscSelectedSection(sections[0]);
  } else {
    setSscSelectedSection("");
  }
}}
                                  label="Select Year"
                                 
                                >
                                  <MenuItem value="Inter-1st-Year">Inter-1st-Year</MenuItem>
                                  <MenuItem value="Inter-2nd-Year">Inter-2nd-Year</MenuItem>
                                </Select>
                                 {errors.romanNumberClass && (
    <FormHelperText>{errors.romanNumberClass}</FormHelperText>
  )}
                              </FormControl>
                          
                              <FormControl size="medium" fullWidth sx={{ mb: 2 }}>
                                <InputLabel id="course-type-label">Select Course</InputLabel>
                                <Select
                                  labelId="course-type-label"
                                  value={selectedCourseType}
                                  onChange={(e) => setSelectedCourseType(e.target.value)}
                                  label="Select Course"
                                  
                                >
                                  {courseOptions.map((course, index) => (
                                    <MenuItem key={index} value={course}>{course}</MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                          
                              <FormControl size="medium" fullWidth sx={{ mb: 2 }}>
                                <InputLabel id="intermediate-section-select-label">Select Section</InputLabel>
                                <Select
                                  labelId="intermediate-section-select-label"
                                  value={interSelectedSection}
                                  onChange={(e) => setInterSelectedSection(e.target.value)}
                                  label="Select Section"
                                  
                                >
                                  {interSectionOptions.map((section, index) => (
                                    <MenuItem key={index} value={section}>{section}</MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </>
                          )}
    
                <TextField
                  name="meetingLink"
                  label="Class Link"
                  value={formData.meetingLink}
                  onChange={handleChange}
                  fullWidth
                  sx={{ mb: 2 }}
                  error={!!errors.meetingLink}
                  helperText={errors.meetingLink}
                />


                <Autocomplete
  options={teacherrecipients}
  getOptionLabel={(option) =>
    `${option.teacherId} (${option.teacherFirstName} ${option.teacherLastName})`
  }
  value={formData.teacherrecipients}
  onChange={(event, newValue) => {
    setFormData((prev) => ({
      ...prev,
      teacherrecipients: newValue,
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      recipients: validateField("recipients", newValue ? [newValue.teacherId] : []),
    }));
  }}
  renderOption={(props, option) => (
    <MenuItem {...props}>
      {`${option.teacherFirstName} ${option.teacherLastName}`}
    </MenuItem>
  )}
  renderInput={(params) => (
    <TextField
      {...params}
      label="Select Teacher"
      fullWidth
      sx={{ mb: 1 }}
      placeholder={teacherrecipients.length === 0 ? "No Teachers Select" : ""}
      error={!!errors.recipients}
      helperText={errors.recipients}
    />
  )}
  noOptionsText="No Teachers To Select"
/>


<TextField
                  name="description"
                  label="Meeting Purpose"
                  multiline
                  rows={3}
                  value={formData.description}
                  onChange={handleChange}
                  // onChange={handleTimeChange}
                  fullWidth
                  sx={{ mb: 1 }}
                  error={!!errors.description}
                  helperText={errors.description}
                />
  

                <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                                  <Button
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    sx={{
                                      backgroundColor: "#6E69B0",
                                      color: "white",
                                      marginTop:"10px",
                                      minWidth: "130px",
                                      "&:hover": {
                                        backgroundColor: "#58548E",
                                      },
                                    }}
                                    disabled={loading} // Disable button while loading
                                  >
                                    {loading ? (
                                      <CircularProgress size={24} sx={{ color: "white" }} />
                                    ) : (
                                      "Schedule Meeting"
                                    )}
                                  </Button>
                                </Box>
              </form>
            </Box>
          </Grid>

          {/* Right Side Display */}
          <Grid item xs={12} md={8}>
            <Box
              sx={{
                padding: "15px",
                borderRadius: "8px",
                boxShadow: "0px 6px 20px rgba(0, 0, 0, 0.25)",
                backgroundColor: "#ffffff",
                height: "100%",
              }}
            >
              <Typography
                variant="h6"
                sx={{ fontWeight: "bold", color: "#333", marginBottom: "15px" }}
              >
                Scheduled Online Classes 
              </Typography>

              <Grid container spacing={2} sx={{ marginBottom: "15px" }}>
                              <Grid item xs={12} sm={6}>
                                <TextField
                                  label="Search by Date or Title"
                                  size="small"
                                  value={searchQuery}
                                  onChange={(e) => setSearchQuery(e.target.value)}
                                  placeholder="YYYY-MM-DD or Title"
                                />
                              </Grid>
                            </Grid>

                  <Box
                       sx={{ borderBottom: "1px solid #ddd", marginBottom: "15px" }}
                   />


<GlobalStyles
                styles={{
                  ".custom-sidebar-scrollbar": {
                    scrollbarWidth: "thin", // For Firefox
                    scrollbarColor: "grey #e0e0e0",
                  },
                  ".custom-sidebar-scrollbar::-webkit-scrollbar": {
                    width: "6px", // For WebKit-based browsers
                  },
                  ".custom-sidebar-scrollbar::-webkit-scrollbar-track": {
                    background: "#f1f1f1", // Track color
                  },
                  ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb": {
                    backgroundColor: "grey", // Thumb color
                    borderRadius: "10px",
                  },
                  ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover": {
                    backgroundColor: "#555",
                  },
                }}
              />

              <Box
                              sx={{
                                maxHeight: "550px",
                                overflowY: "auto",
                                paddingRight: "10px",
                              }}
                              className="custom-sidebar-scrollbar"
                            >
                              <Grid container spacing={2}>
                                {loadingData ? ( // Show loader when loading
                                                        <Box display="flex" flexDirection="column" alignItems="center" width="100%" sx={{ mt: 2 }}>
                                                          <CircularProgress />
                                                          <Typography variant="body2" sx={{ mt: 1 }}>
                                                            Loading Meetings List...
                                                          </Typography>
                                                        </Box>
                                                      
                          ) : filteredMeetings.length === 0 ? (
                                  <Typography
                                    variant="h6"
                                    sx={{
                                      textAlign: "center",
                                      color: "#666",
                                      width: "100%",
                                      padding: "20px",
                                      fontStyle: "italic",
                                    }}
                                  >
                                    No Meetings Found, Schedule A New Meeting.
                                  </Typography>
                                ) : (
                                  filteredMeetings.map((data, index) => (
                                    <Grid item xs={12} key={index}>
                          
                                       <Box
                                        sx={{
                                          padding: "10px",
                                          borderRadius: "10px",
                                          boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
                                          backgroundColor: "#D1E9F6",
                                          position: "relative",
                                          overflow: "hidden",
                                          marginTop: "10px",
                                          transition: "all 0.2s ease-in-out",
                                          "&:hover": {
                                            backgroundColor: "#b3d8ec", // Slightly darker shade on hover
                                          },
                                          "&:hover .delete-button": { opacity: 1 }, // Show delete button on hover
                                        }}
                                      >
                                        {/* "New!" Ribbon Badge */}
                                       {(() => {
  try {
    if (!data.meetingDate) return null;

    const now = new Date();
    const createdTime = new Date(data.meetingDate);

    const diffInHours = (now - createdTime) / (1000 * 60 * 60);

    const isNew = diffInHours <= 24; // show badge if created within last 24 hours

    return isNew ? (
      <Box
        sx={{
          position: "absolute",
          top: "0",
          right: "0",
          backgroundColor: "blue",
          color: "#fff",
          fontWeight: "bold",
          fontSize: "0.75rem",
          padding: "5px 10px",
          textTransform: "uppercase",
          borderTopRightRadius: "8px",
          borderBottomLeftRadius: "8px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
        }}
      >
        New!
      </Box>
    ) : null;
  } catch (error) {
    console.error("New! badge error:", error);
    return null;
  }
})()}



                                      
                                        {/* Delete Icon - Now positioned correctly and shown only on hover */}
                                        <IconButton
                                        className="delete-button"
                                        sx={{
                                          position: "absolute",
                                          right: "10px", // Keep it aligned to the right
                                          top: "50%", // Center vertically
                                          transform: "translateY(-50%)", // Adjust for exact centering
                                          backgroundColor: "#ff0000",
                                          color: "#fff",
                                          opacity: 0, // Initially hidden
                                          transition: "opacity 0.2s ease-in-out",
                                          "&:hover": { backgroundColor: "#d32f2f" },
                                        }}
                                        onClick={() => handleDeleteMeeting(data)}
                                      >
                                        <DeleteIcon />
                                      </IconButton>
                                      
                                      
                                        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                          <Box
                                          sx={{
                                            backgroundColor: "#00796B",
                                            color: "#FFFFFF",
                                            borderRadius: "8px",
                                            padding: "10px",
                                            fontSize: "0.9rem",
                                            display: "inline-flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            height: "40px",
                                            width: "200px", // made wider to fit full text
                                            fontWeight: "bold",
                                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                                          }}
                                        >
                                          {`Date: ${
                                            Array.isArray(data.meetingDate)
                                              ? `${String(data.meetingDate[2]).padStart(2, "0")}-${String(data.meetingDate[1]).padStart(2, "0")}-${data.meetingDate[0]}`
                                              : "N/A"
                                          }`}
                                        </Box>

                                      
                                          <Box
                                            sx={{
                                              backgroundColor: "#4682B4",
                                              color: "#fff",
                                              borderRadius: "8px",
                                              padding: "10px",
                                              fontSize: "0.9rem",
                                              display: "inline-flex",
                                              alignItems: "center",
                                              justifyContent: "center",
                                              height: "40px",
                                              width: "100px",
                                              fontWeight: "bold",
                                              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                                            }}
                                          >
                                            {data.time}
                                          </Box>
                                        </div>
                                         <Box display="flex" alignItems="center" gap={0.5} mt={2}>
  <Typography variant="h6" fontWeight="bold" color="#333">
    Title:
  </Typography>

  <Typography
    variant="h5"
    // fontWeight="bold"
    color="#333"
    sx={{ wordBreak: "break-word" }}
  >
    {data.title}
  </Typography>
</Box>
<Box display="flex" alignItems="center" gap={1} mt={1}>
  <Typography variant="h6" fontWeight="bold" color="#333">
    Class:
  </Typography>

  <Typography
    variant="h5"
    // fontWeight="bold"
    color="#333"
    sx={{ wordBreak: "break-word" }}
  >
   {data.romanNumberClass} | {board === "INTERMEDIATE" &&(data.course)} | {data.sections}
  </Typography>
</Box>
                                      
                                        
                                        <Box display="flex" alignItems="center" gap={1} mt={1}>
  <Typography variant="h6" fontWeight="bold" >
    Class Link:
  </Typography>

  <Link
    href={data.meetingLink}
    target="_blank"
    rel="noopener noreferrer"
    underline="hover"
    sx={{
      color: "#0054CB",
      fontWeight: 500,
      wordBreak: "break-all", // ensures long URLs wrap
    }}
  >
    {data.meetingLink}
  </Link>
</Box>



                                      <Box display="flex" alignItems="center" gap={1} mt={1}>
                                          <Typography variant="h6" fontWeight="bold" >
    Meeting Purpose:
  </Typography>

                                        <Typography
                                          variant="body2"
                                          sx={{
                                            color: "#666",
                                            fontWeight: "bold",
                                            marginTop: "5px",
                                          }}
                                        >
                                          {data.description}
                                        </Typography>
                                        </Box>


                                                              </Box>
                                    </Grid>
                                  ))
                                )}
                              </Grid>
                            </Box>

            </Box>
          </Grid>
        </Grid>
      </CardContent>

      <ToastContainer position="top-right" autoClose={2000} hideProgressBar theme="light" />
    </Card>
  );
}

export default DigitalClasses;